export default __webpack_public_path__ + "static/media/download-circle-blue.58b7450c.svg";